/* eslint-disable react/no-unescaped-entities */
import React, { useState, useContext } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container'; // Import Container
import Avatar from '@mui/material/Avatar'; // Import Avatar
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'; // Import Icon
import { useForm } from 'react-hook-form';
// Card ถูกเอาออกไป แต่ถ้ายังอยากใช้ Card หุ้มอีกชั้นก็ทำได้ครับ
// import Card from '@mui/material/Card'; 
import { getStorage } from '../../utils/functions/localstorage';
import Loading from '../../components/Loading';
import { PassportAuth } from '../../contexts/AuthContext';

function Login() {
  const { handleAdminSignin } = useContext(PassportAuth);
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      await handleAdminSignin(data.email, data.password);
      navigate('/invoice-main');
    } catch (error) {
      console.error(error);
      alert('เข้าสู่ระบบไม่สำเร็จ');
      setIsLoading(false);
    }
  };

  return getStorage('token') ? (
    <Navigate to="/invoice-main" />
  ) : (
    // ใช้ Box ของ MUI มาจัด Layout และกำหนดพื้นหลัง
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        // เปลี่ยนพื้นหลังเป็นสีเทาอ่อนๆ ที่ดูสะอาดตา
        backgroundColor: (theme) => theme.palette.grey[100], 
      }}
    >
      <Loading isLoading={isLoading} />
      <CssBaseline />
      {/* ใช้ Container เพื่อจำกัดความกว้างของฟอร์มให้เหมาะสม */}
      <Container component="main" maxWidth="xs">
        {/* คุณสามารถใช้ Card หุ้ม Box ด้านล่างนี้ได้ถ้าต้องการให้มีกรอบลอยๆ
          <Card sx={{ padding: 4, borderRadius: 2, boxShadow: 3 }}> 
        */}
        <Box
          sx={{
            // padding: 4, // (ถ้าใช้ Card ให้ย้าย padding มาที่นี่แทน)
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            // เพิ่ม padding และพื้นหลังสีขาวเพื่อให้ดูเหมือน Card
            backgroundColor: 'white',
            padding: { xs: 3, md: 4 },
            borderRadius: 2,
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          }}
        >
          {/* 1. เพิ่ม Avatar และ Icon รูปแม่กุญแจ */}
          <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          {/* 2. เปลี่ยน Title ให้สื่อถึง Admin */}
          <Typography component="h1" variant="h5">
            Admin Sign In
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit(onSubmit)}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              {...register('email')}
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              {...register('password')}
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 ,color:'white'}}
            >
              {/* 3. ลบ <div> ที่ไม่จำเป็นออก */}
              Sign In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link
                  href="https://one.th/type_forgot_password"
                  variant="body2"
                >
                  Forgot password?
                </Link>
              </Grid>
              {/* 4. (ข้อเสนอแนะ) ระบบ Admin มักไม่มี "Sign Up" */}
              {/* <Grid item>
                <Link href="https://one.th/register" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid> 
              */}
            </Grid>
          </Box>
        </Box>
        {/* </Card> */}
      </Container>
    </Box>
  );
}

export default Login;